import '@csstools/normalize.css/normalize.css';
import ApolloThemeProvider from 'apollo-react/utils/ApolloThemeProvider';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./i18n/configs";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<ApolloThemeProvider>
			<App />
		</ApolloThemeProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
